export const hexToRgb = (color: string) =>
  /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i
    .exec(color)
    ?.slice(1)
    .map((x) => parseInt(x, 16))
    .join(' ') || '';

// expects `${r} ${g} ${b}` e.g. '255 255 255'
export const rgbToHex = (color: string) =>
  `#${color
    .split(' ')
    .map((x) => parseInt(x, 10).toString(16).padStart(2, '0'))
    .join('')}`;
